export const csrfToken = document
  .querySelector('meta[name="csrf-token"]')
  .getAttribute('content')
